import Section from '@components/Section';
import { Link as GLink } from 'gatsby';
import React, { useEffect } from 'react';
import {
  Card, Flex, Grid, Heading, Link,
} from 'theme-ui';

// Стиль для элементов списка
const styles = {
  number: {
    color: 'omega',
    width: '2rem',
    mr: 3,
    mb: 0,
  },
  text: {
    flex: '1',
    ':hover': {
      color: 'alphaDark',
    },
    mb: 0,
  },
  link: {
    textDecoration: 'none',
  },
};

// Функция для "флэттенинга" вложенных элементов
const flattenItems = (items, level = 1) => {
  let result = [];
  items.forEach(item => {
    // Добавляем текущий элемент в результат только если у него есть заголовок
    if (item.title && item.title.trim() !== '') {
      result.push({ ...item, level });
    }
    // Рекурсивно добавляем вложенные элементы, если они есть
    if (item.items && item.items.length > 0) {
      result = result.concat(flattenItems(item.items, level + 1));
    }
  });
  return result;
};

const TableOfContentsExpanded = ({
                                   tableOfContents: { items = [] },
                                   columns,
                                 }) => {
  // Флаттенинг элементов
  const flattenedItems = flattenItems(items);

  // Проверка на пустые данные
  if (flattenedItems.length === 0) {
    return null; // Если нет заголовков, не отображаем компонент
  }

  return (
    <Section title="Table Of Contents">
      <Card variant="paper">
        <Grid
          sx={{
            gridRowGap: 1,
            gridAutoFlow: ['row', null, 'column'],
            gridTemplateRows: [
              'auto',
              null,
              `repeat(${Math.ceil(flattenedItems.length / columns)}, 1fr)`,
            ],
          }}
        >
          {flattenedItems.map((item, index) => (
            item.title && item.title.trim() !== '' ? ( // Проверка на пустой заголовок
              <Link
                key={`item-${index}`}
                as={GLink}
                to={item.url}
                variant="vertical"
                sx={styles.link}
              >
                <Flex>
                  <Heading variant="h3" as="div" sx={styles.number}>
                    {(index + 1).toLocaleString('en-US', {
                      minimumIntegerDigits: 2,
                      useGrouping: false,
                    })}
                  </Heading>
                  <Heading variant="h4" as="div" sx={styles.text}>
                    {item.title}
                  </Heading>
                </Flex>
              </Link>
            ) : null // Если заголовок пустой, не отображаем
          ))}
        </Grid>
      </Card>
    </Section>
  );
};

TableOfContentsExpanded.defaultProps = {
  columns: 2,
};

export default TableOfContentsExpanded;
